import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS';
import pushConfig from '../../../push-config.json'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram';
import Translation from '../../Translation/cont/Translation';
import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import { Redirect } from "react-router-dom"

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = (dispatch, ownProps) => ({})

const PushContainer = ({
    match,
    closePagePath
}) => {

    let pushAction = "list"

    return (
        <Redirect to={`${config.routes.push.path}/create/`} />
    )

    // return (
    //     <WrapperPageSimple
    //         pageTitle={[<Translation key="name_one" id={pushConfig.routes[pushAction].transIdname} />]}
    //         closePagePath={closePagePath} >
                
    //     </WrapperPageSimple>
    // )
}

export default compose(
    connect(mapStateToProps, null),
    hasUpdateProgram(),
    toJS()
)(PushContainer)